import styled from "styled-components";
import { InputField } from "../commonStyles";

export const CurrencyInputField = styled(InputField)`
  ${props => props.fullWidth && `width: 100% !important;`}
  padding: 4px 11px !important;
  @media only screen and (max-width: 767px) {
    max-width: unset !important;
  }
`;
